<template>
  <div class="tabs-list">
    <div v-for="(item, $index) in list" :key="$index" class="tab-item" @click="goDetail(item)">
      <p class="tab-title">{{item.title}}</p>
      <div class="tab-label">
        <span>{{item.showTime | showtime}}</span>
      </div>
    </div>
    <!-- <infinite-loading ref="gonggaoinf" @infinite="infiniteHandler" direction="bottom" :distance="100" :forceUseInfiniteWrapper="true">
      <div slot="no-more">无更多数据</div>
      <div v-if="list.length === 0" slot="no-results" class="no-results">
      </div>
      <div v-else slot="no-results">
      </div>
      <div slot="spinner" class="tab-spinner">正在加载...</div>
    </infinite-loading> -->
  </div>
</template>

<script>
import moment from 'moment'
// import InfiniteLoading from 'vue-infinite-loading'
import { request } from '@/api/request'
import {mapState, mapMutations} from 'vuex'

export default {
  data(){
    return {
      //list: []
    }
  },
  computed: {
    ...mapState({
      code: state => state.code,
      market: state => state.market,
      tabs: state => state.common.tabs,
      symbol: state => state.symbol,
      tabIndex: state => state.common.tabIndex
    }),
    list() {
      let focusList = this.tabs.filter(v => v.key === 'focus')[0].list;
      return focusList.length > 0 ? focusList : this.getListData(true)
    }
  },
  mounted() {
    console.log('mounted tabs',this.tabs)
  },
  activated() {
    this.getListData()
  },
  // components: {InfiniteLoading},
  methods: {
    ...mapMutations({
      setTabs: 'common/setTabs'
    }),
    goDetail(data) {
      // console.log('gonggao', gonggao)
      this.$router.push(`/detail/${this.market}/${this.symbol}/4/${data.newsId}.html`)
    },
    async infiniteHandler($state) {
      let canload = await this.getListData()
      if (canload) $state.loaded()
      else $state.complete()
    },
    /**
     * 获取list 数据
     */
    async getListData() {
      let res = await request.get({
        url: request.apis.news.getSpecifiedColumnList,
        params: {
          market: this.market,
          symbol: this.code,
          columnCodes: '9fztgw_jfsd',
          appCode: '9fztgw',
          showPermission: 0,
        },
        headers: {
          whiteList: 'rjhy-news'
        }
      })
      if (!res.newsList || !res.newsList.length) return
      const data = this.tabs.filter(v=>v.key == 'focus')[0]
      data.label = res.columnBeans['9fztgw_jfsd']
      data.list = res.newsList
      this.setTabs(this.tabs)
      return data.list
    }
  },
  filters: {
    showtime(_date) {
      let day = moment(new Date())
      let date = moment(_date)
      if (day.year() === date.year() && day.dayOfYear() === date.dayOfYear()) {
        return `${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else if (day.year() === date.year()) {
        return `${(date.month() + 1).toString().padStart(2, 0)}-${date.date().toString().padStart(2, 0)} ${date.hour().toString().padStart(2, 0)}:${date.minute().toString().padStart(2, 0)}`
      } else {
        return `${date.year()}-${date.month() + 1}-${date.date()}`
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
.tabs-list
  display flex
  flex-flow column
  .no-results
    background url('../../../assets/no_data.png')
    height 200px
    width 200px
    background-size cover
    margin 50px auto
  .tab-spinner
    font-size 13px
    padding 15px 0 30px 0
    color: #999
  .tab-item
    padding 10px 8px
    border-bottom 1px solid #f5f5f5
    .tab-title
      font-size 15px
      color #333
      // height 22px
      line-height 21px
      font-weight 400
      text-overflow: -o-ellipsis-lastline
      overflow: hidden
      text-overflow: ellipsis
      display: -webkit-box
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
    .tab-label
      display flex
      justify-content space-between
      font-size 12px
      color #999
      margin-top 5px
</style>